import React, {useEffect} from 'react';
import {connect} from "react-redux";
import actions from '../../../redux/actions/index';
import {withTranslation} from "react-i18next";
import _ from 'lodash';
import Multiselect  from 'react-multi-select-component';
import * as constants from '../../../constants'

const lotsDropdown = (props) => {

    const {establishmentLots, selectedEstablishment, selectedEstablishmentLotMode} = props;

    useEffect(() => {
        if(selectedEstablishment) props.getUserEstablishmentById(selectedEstablishment._id, ()=> {});
    }, [selectedEstablishment]);

    const strings = {
        "selectSomeItems": "Lotes...",
        "allItemsAreSelected": "Todos seleccionados.",
        "selectAll": "Todos los Lotes",
        "search": "Buscar lote"
    }

    const changeValue = (lots) => {
        props.selectLot(lots)
        let lotIds = lots.map(lot => ( lot.value ))
        if (lotIds.length === 0) lotIds = 0;
        props.getPageByEstablishment(props.selectedEstablishment._id, lotIds, 1, 10)
    };

    const showDropdown = () => {
        //const validMode = selectedEstablishmentLotMode != "lotModeDisabled";
        const lotsToShow = establishmentLots && establishmentLots.length > 0;
        return lotsToShow;
        //return lotsToShow && validMode;
    }

    if(showDropdown()) {
        return (
            <div>
                {
                <Multiselect
                    options={
                        [...establishmentLots, {_id: constants.NOT_ASSIGNED, name: 'Sin Lote'}].map(lot => ({
                            value: lot._id,
                            label: lot.name
                        }))
                    }
                    displayValue="name"
                    name="lotsDropdown"
                    value={props.selectedLots}
                    onChange={(e)=>changeValue(e)}
                    overrideStrings={strings}
                    hasSelectAll={establishmentLots.length>1}
                />
                }
            </div>
        );
    }
    return null
};

const mapStateToProps = (state) => ({
    establishments: state.user.allEstablishmentsByCompany,
    selectedCompany: state.user.selectedCompany,
    selectedLot: state.user.selectedLot,
    selectedEstablishment: state.user.selectedEstablishment,
    roles: state.user.roles,
    userId: state.user.id,
    selectedEstablishmentLotMode: state.user.establishmentDetails?
        state.user.establishmentDetails.animalLots.mode : null,
    establishmentLots: state.user.establishmentDetails?
        state.user.establishmentDetails.animalLots.lots : null,
    selectedLots: state.user.selectedLots,
});

const mapDispatchToProps = (dispatch) => ({
    getUserEstablishmentById: (currentEstablishment) =>
    dispatch(actions.user.getEstablishmentById(currentEstablishment)),
    selectLot: (lot) => dispatch(actions.user.selectLot(lot)),
    resetSelectedEstablishment: () => dispatch(actions.user.resetSelectedEstablishment()),
    getAssignedEstablishments: (userId) => dispatch(actions.user.getAssignedEstablishments(userId)),
    getPageByEstablishment: (establishmentId, lotId, page, pageSize) =>
        dispatch(actions.animal.getPageByEstablishment(establishmentId, lotId, page, pageSize))
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('common')(lotsDropdown))
